import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import PlantYogurtProduct from 'models/PlantYogurtProduct'
import PlantYogurtNutrition from './PlantYogurtNutrition'
import PlantYogurtPackage from './PlantYogurtPackage'

const productOptions = {
  nutritionInfo: <PlantYogurtNutrition />,
  packagingInfo: <PlantYogurtPackage />,
  productTitle: 'Brand Specific Plant-Based Yogurt Alternatives',
  model: PlantYogurtProduct,
  validCategories: ['00'],
  validSubCategories: ['001'],
}

const PlantYogurt = () => <ProductForm product={productOptions} />

export default PlantYogurt
